<template>
  <notification-pop-up
    :notification-type="notification.type"
    :can-dismiss="notification.clickToDismiss"
    @close-notification="closeNotificationClickHandler"
  >
    <div class="cf-flex cf-flex--column cf-flex--gap-14">
      <h4
        id="notification-content"
        class="cf-title cf-title--4"
      >
        <span
          v-if="notification.subject"
          class="cf-title--extra-heavy"
        >
          {{ notification.subject }}
        </span>

        <span v-html="notification.message" />
      </h4>

      <a
        v-if="notification.url"
        class="cf-button cf-button--tertiary cf-button--xs cf-text-capitalize"
        target="_blank"
        :href="notification.url"
        @click="closeNotificationClickHandler"
      >
        <p class="cf-subtitle cf-subtitle--3 cf-subtitle--heavy">{{ notification.buttonText || 'OK' }}</p>
      </a>
    </div>
  </notification-pop-up>
</template>


<script>
  import NotificationPopUp from '../../shared/notification-pop-up/index.vue';


  export default {
    name: 'CfNotification',

    components: {
      NotificationPopUp
    },

    props: {
      notification: {
        type: Object,
        required: true
      }
    },

    methods: {
      closeNotificationClickHandler() {
        this.$emit('close-notification', this.notification);
      }
    }
  };
</script>
